"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.falseDocs = void 0;
var falseDocs = {
  name: 'false',
  category: 'Constants',
  syntax: ['false'],
  description: 'Boolean value false',
  examples: ['false'],
  seealso: ['true']
};
exports.falseDocs = falseDocs;